const getBaseVariables = () => {
  return {
    x1: 46,
    x2: 146,
    x3: 246,
    x4: 346,
    x5: 446,
    x6: 546,
    x7: 646,

    weekday_month1_y: 550,

    y1: 505,
    y2: 460,
    y3: 415,
    y4: 370,
    y5: 325,
    y6: 280,

    weekday_month2_y: 235,

    y7: 190,
    y8: 145,
    y9: 100,
    y10: 55,

    width: 100,
    height: 45,
  };
};

export default getBaseVariables;
